/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from '@polleverywhere/backbone'

const DEFAULTS = {
  page: 1,
  search: '',
  order: '',
  direction: ''
}

export default class Filter extends Backbone.Model {
  get defaults () { return DEFAULTS }

  resetSearchParams () {
    return this.clear().set(DEFAULTS)
  }
}
